export default __webpack_public_path__ + "static/media/030_corner1.hevc.b58ffbd1.mp4";